import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReportGenerationState {
  isGenerating: boolean;
}

const initialState: ReportGenerationState = {
  isGenerating: false,
};

export const reportGenerationSlice = createSlice({
  name: 'reportGeneration',
  initialState,
  reducers: {
    setIsGenerating: (state, action: PayloadAction<boolean>) => {
      state.isGenerating = action.payload;
    },
    startGenerating: state => {
      state.isGenerating = true;
    },
    stopGenerating: state => {
      state.isGenerating = false;
    },
  },
});

export const { setIsGenerating, startGenerating, stopGenerating } =
  reportGenerationSlice.actions;

export default reportGenerationSlice.reducer;
